import { graphql } from "gql";

// IMPORTANT: when adding additional variables to this query, make sure to add
// them to keyArgs in `src/modules/services/app-graphql-client/app-graphql-client.ts`
// (page and pageSize are exceptions and should not be included, otherwise load more pagination will break)

const FIND_MESSAGE_THREADS_QUERY = graphql(`
  query findMessageThreads($input: FindInput!) {
    find(input: $input) {
      ...MessageThread
    }
  }
`);

export default FIND_MESSAGE_THREADS_QUERY;
